import React from 'react';
import { Chip } from '@mui/material';
import {
  getMenuCategoryTone,
  type CategoryTone
} from '../../themes/labels';
import type { CategoryChipProps } from './label.types';
import { getCategoryChipSx } from './label.styles';

const CategoryChip: React.FC<CategoryChipProps> = ({
  label,
  tone,
  categoryKey,
  size = 'small',
  selected = false,
  icon,
  onClick
}) => {
  const resolvedTone: CategoryTone =
    tone ?? (categoryKey ? getMenuCategoryTone(categoryKey) : 'neutral');

  return (
    <Chip
      label={label}
      icon={icon as React.ReactElement | undefined}
      size="small"
      clickable={Boolean(onClick)}
      onClick={onClick}
      sx={getCategoryChipSx(resolvedTone, size, selected)}
      aria-label={label}
      aria-pressed={selected || undefined}
    />
  );
};

export default CategoryChip;
